import { Conversation } from '../services/types/client-intake-types';

/**
 * Convert a snake_case column ID to a human-readable title.
 * e.g. "last_client_contact" → "Last Client Contact"
 */
export const humanizeColumnId = (id: string): string => {
  if (!id.includes('_')) return id;
  return id
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

/**
 * Format a date string to short format (e.g., "Jan 15, 2024")
 * Returns null for invalid or missing dates.
 */
export const formatShortDate = (
  dateStr: string | null | undefined,
): string | null => {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

/**
 * Format a date string to compact format without year (e.g., "Jan 15")
 * Returns null for invalid or missing dates.
 */
export const formatCompactDate = (
  dateStr: string | null | undefined,
): string | null => {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

export function formatCallDuration(
  currentTimeSeconds: number,
  totalDurationSeconds: number,
): string {
  const formatTime = (timeInSeconds: number) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    const formattedHours = hours > 0 ? `${hours}:` : '';
    const formattedMinutes = `${minutes < 10 && hours > 0 ? '0' : ''}${minutes}:`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

    return `${formattedHours}${formattedMinutes}${formattedSeconds}`;
  };

  const currentTimeFormatted = formatTime(currentTimeSeconds);
  const totalDurationFormatted = formatTime(totalDurationSeconds);
  return currentTimeSeconds > 0
    ? `${currentTimeFormatted}`
    : totalDurationFormatted;
}

export function formatIntakeCall(conversation: Conversation): string {
  if (!conversation) {
    return '';
  }
  const { start_timestamp } = conversation;
  if (!start_timestamp) {
    return '';
  }

  const date = new Date(start_timestamp);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString('en-US', options);
  //  TODO add firm user name
  return `${formattedDate}`;
}
